var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "17px",
    viewBox: "0 0 20 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "342F74CE-B8C9-4674-A708-854C0A36D1D5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card-fields",
    transform: "translate(-359.000000, -456.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "credit-card-(1)",
    transform: "translate(359.000000, 456.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.48102,0.518688525 C19.1551548,0.192823315 18.7634244,0.0299089253 18.3058652,0.0299089253 L1.66415301,0.0299089253 C1.20652095,0.0299089253 0.814863388,0.192786885 0.488779599,0.518688525 C0.16287796,0.844626594 0,1.23628415 0,1.69395264 L0,14.3414208 C0,14.7991985 0.16287796,15.1908925 0.488779599,15.5167942 C0.814863388,15.8426958 1.20652095,16.0056466 1.66415301,16.0056466 L18.3058652,16.0056466 C18.7634244,16.0056466 19.1551184,15.8426958 19.48102,15.5167942 C19.8068852,15.190929 19.9699818,14.799235 19.9699818,14.3414208 L19.9699818,1.69395264 C19.9699818,1.23628415 19.8068852,0.844626594 19.48102,0.518688525 Z M18.6385428,14.3416758 C18.6385428,14.431949 18.6056102,14.5097268 18.539745,14.5758106 C18.4739162,14.6413843 18.3958834,14.6742805 18.3058652,14.6742805 L1.66415301,14.6742805 C1.57406193,14.6742805 1.49602914,14.6413843 1.43016393,14.5755556 C1.36433515,14.5095082 1.33136612,14.431694 1.33136612,14.3414208 L1.33136612,8.01777778 L18.6385428,8.01777778 L18.6385428,14.3416758 L18.6385428,14.3416758 Z M18.6385064,4.02364299 L1.33132969,4.02364299 L1.33132969,1.69380692 C1.33132969,1.60367942 1.36418944,1.52582878 1.4301275,1.45981785 C1.49602914,1.39413479 1.57406193,1.36116576 1.66411658,1.36116576 L18.3058288,1.36116576 C18.395847,1.36116576 18.4738798,1.39398907 18.5397086,1.45981785 C18.6055738,1.52582878 18.6385064,1.60367942 18.6385064,1.69380692 L18.6385064,4.02364299 L18.6385064,4.02364299 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 2.66273224,
    y: 12.0116211,
    width: 2.66262295,
    height: 1.33143898
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6.65675774,
    y: 12.0116211,
    width: 3.99395264,
    height: 1.33143898
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.7da7fe0ae3f2be1d58c9e557e30f8553.svg";
export { ForwardRef as ReactComponent };